export function getLast<T>(arr: T[]): T | undefined {
  return arr[arr.length - 1];
}
export function getLastTwo<T>(arr: T[]): T | undefined {
  return arr[arr.length - 2];
}

const API_BASE = process.env.NODE_ENV == 'development' ?
  (process.env.NEXT_PUBLIC_API_BASE ?? '').replace(/\/+$/, '') : ""; // 뒤 슬래시 제거

export function mediaUrl(path: string | null) {
  if(path == null) return ""
  // path는 '/media/xxx' 또는 'media/xxx' 모두 허용
  const p = path.startsWith('/') ? `${API_BASE}${path}` : `${path}`;
  
  return `${p}`;
} 

export const checkIsStandalone = (): boolean => {
  if (typeof window === "undefined") return false;

  const isDisplayModeStandalone =
    window.matchMedia("(display-mode: standalone)").matches;

  const isIosStandalone =
    (window.navigator as Navigator & {
      standalone?: boolean;
    }).standalone === true;

  return isDisplayModeStandalone || isIosStandalone;
};